import React, { Component } from 'react';
import { Form, Input, Label, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class DermatologistSystem extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="DermatologistSystem">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="DermatologistSystem__Form"
        >
          <h1>{translate('fiche.dermatologist_system.title')}</h1>

          <Label
            text={translate('fiche.dermatologist_system.skin_mucous_membrane')}
          />
          <Input
            name="skin_mucous_membrane"
            defaultValue={data.skin_mucous_membrane}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(DermatologistSystem);
